// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import api from './utils/api'
import VueAnimateNumber from 'vue-animate-number'
Vue.use(VueAnimateNumber)
Vue.config.productionTip = false

import axios from 'axios'
Vue.prototype.$axios = axios;
Vue.prototype.$api = api;
new Vue({
  el: '#app',
  router,
  render: h => h(App)
}).$mount('#app')


// WEBPACK FOOTER //
// ./src/main.js